<template>
    <div class="carousel__item">
        <div v-if="type === 'text'"
             class="carousel__content carousel__content--no-image">
            <div class="row">
                <div class="col">
                    <div class="carousel__title-wrapper">
                        <h4>{{ title }}</h4>
                    </div>
                </div>
            </div>
            <div class="row">
                <div class="col">
                    <p>{{ text }}</p>
                </div>
            </div>
        </div>

        <div
            v-if="type === 'image'"
            class="carousel__content carousel__content--image">
            <div class="row">
                <div class="col-auto">
                    <img
                        v-if="imgSrc"
                        class="img-fluid carousel__image"
                        :src="imgSrc"
                        alt="Image Title">
                </div>
                <div class="col">
                    <div class="carousel__title-wrapper">
                        <h4>{{ title }}</h4>
                    </div>
                    <p class="carousel__text">
                        {{ text }}
                    </p>
                </div>
            </div>
        </div>

        <div
            v-if="type === 'small-image'"
            class="carousel__content carousel__content--image">
            <div class="row">
                <div class="col-auto">
                    <img
                        v-if="imgSrc"
                        class="img-fluid carousel__image--small"
                        :src="imgSrc"
                        alt="Image Title">
                </div>
                <div class="col">
                    <div class="carousel__title-wrapper">
                        <h4>{{ title }}</h4>
                    </div>
                    <p>{{ text }}</p>
                    <p v-if="name && position">
                        {{ name }},
                        {{ position }}
                    </p>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
export default {
    name: 'ThemeCarouselSlideVue',
    props: {
        type: {
            type: String,
            required: false,
            default: 'text',
            validator (value) {
                return ['text', 'image', 'small-image'].indexOf(value) !== -1;
            },

        },
        imgSrc: {
            type: String,
            required: false,
            default: null,
        },
        titleIconType: {
            type: String,
            required: false,
            default: null,
        },
        title: {
            type: String,
            required: true,
        },
        text: {
            type: String,
            required: true,
        },
        name: {
            type: String,
            required: false,
            default: null,
        },
        position: {
            type: String,
            required: false,
            default: null,
        },
        width: {
            type: Number,
            required: false,
            default: 48,
        },
        height: {
            type: Number,
            required: false,
            default: 49,
        },
    },
};
</script>

<style scoped lang="scss">
    div > div.carousel__item.is-selected {
        .carousel__content, .carousel__content--image {
            background: $mb-lightgreen;
        }
    }

    .carousel__item {
        min-width: 100%;
        width: 100%;

        @include media-breakpoint-down(xs) {
            background-color: $mb-lightgreen;
            padding-right: 15px;
            min-height: 192px;
            overflow: hidden;
            box-shadow: 0px 2px 4px rgba(0, 0, 0, 0.25);
            min-width: 600px;
            flex: 1;
        }

        p {
            margin-top: 10px;
            color: $white;
            margin-bottom: 10px;
        }

        h4 {
            margin-bottom: 0;
            color: $mb-darkgreen;
        }
    }

    .carousel__image {
        @include media-breakpoint-down(xs) {
            width: 225px;
            object-fit: cover;
            height: 285px;
        }

        &--small {
            @include media-breakpoint-down(xs) {
                width: 215px;
                object-fit: cover;
                height: 285px;
            }
        }
    }

    .carousel__content {
        @include media-breakpoint-up(lg) {
            padding-right: 62px;
            min-width: 100%;
            width: 100%;
            font-size: 16px;
            line-height: 26px;
            color: #50585b;
        }
    }

    .carousel__title-wrapper {
        padding-top: 20px;
        display: flex;
    }

    .carousel__content--no-image {
        padding-right: 62px;
        padding-left: 62px;
    }

    .carousel__title-icon {
        margin: 6px 15px 0 5px;

        @include media-breakpoint-down(xs) {
            margin: 0 10px 0 0;
        }

        svg {
            @include media-breakpoint-down(xs) {
                max-height: 36px;
            }
        }
    }
</style>
